import { UserInfoContext } from "Context/CommonContext";
import { useContext, useEffect, useState } from "react";
import "./index.css";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import {
  BASE_URL,
  GET_CONTENT_LICENCE,
  GET_SIGNED_URL,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import PDFPageviewer from "Pages/PlannerView/PDFPageviewer";
// import { Spinner } from "reactstrap";
import ErrorView from "Pages/AssetView/ErrorView";

interface IAssetInfo {
  courseId?: number | string;
  assetId?: number | string;
  title?: string;
  type?: string;
  desc?: string;
}

const PDFView = ({ assetId, courseId }: IAssetInfo) => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  console.log(userInfo, assetId, "scheduleAssetData");
  const [pdfUrl, setPdfUrl] = useState<string>("");
  const [pdfPassword, setPdfPassword] = useState<string | null>(null);
  const { makeRequest: fetchFile, loading } = useGetApi(
    (data: any) => {
      console.log("pdfurl", data);
      setPdfUrl(data?.detailMessage);
    },
    (error: any) => {
      console.error(error);
    }
  );
  const { makeRequest: fetchFileDecryptionKey } = useGetApi(
    (data: any) => {
      if (data?.detailMessage) {
        const decodedKey = atob(data?.detailMessage);
        setPdfPassword(decodedKey);
      } else {
        setPdfPassword("NO_PASSWORD");
      }
    },
    (error: any) => {
      setPdfPassword("NO_PASSWORD");
      console.error(error);
    }
  );
  useEffect(() => {
    fetchFile(
      BASE_URL + GET_SIGNED_URL + `?assetId=${assetId}&courseId=${courseId}`
    );
    fetchFileDecryptionKey(
      BASE_URL +
        GET_CONTENT_LICENCE +
        `?assetId=${assetId}&courseId=${courseId}`
    );
  }, [assetId]);
  return (
    <div className="modern-pdf-view-container">
      {loading ? (
        <div className="modern-loading-container">
          <div className="modern-spinner"></div>
          <span className="loading-text">Loading PDF...</span>
        </div>
      ) : pdfUrl != "" && pdfPassword != null ? (
        <PDFPageviewer
          allPageInOne={true}
          pdfUrl={pdfUrl}
          pdfPassword={pdfPassword}
          isLibraryView={true}
          parentComponent="AssetView"
        />
      ) : (
        <div className="modern-error-container">
          <ErrorView />
        </div>
      )}
    </div>
  );
};

export default PDFView;
